<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';

const props = defineProps({
  signature: { type: String, default: '' },
  position: { type: String, default: 'bottom' }, // 'top' | 'bottom'
});

const { t } = useI18n();
const { formatMessage } = useMessageFormatter();

const formattedSignature = computed(() =>
  formatMessage(props.signature || '', false, false)
);

const positionLabel = computed(() =>
  props.position === 'top'
    ? t('CONVERSATION.REPLYBOX.SIGNATURE_PREVIEW.POSITION_TOP')
    : t('CONVERSATION.REPLYBOX.SIGNATURE_PREVIEW.POSITION_BOTTOM')
);
</script>

<template>
  <div
    class="flex flex-col gap-1 px-3 py-2 rounded-lg border border-dashed border-n-weak bg-n-alpha-1 text-n-slate-11"
  >
    <div class="flex items-center gap-1.5 text-[10px] uppercase tracking-wide font-semibold">
      <span class="i-ph-pen-nib-light" />
      <span>{{ t('CONVERSATION.REPLYBOX.SIGNATURE_PREVIEW.LABEL') }}</span>
      <span class="text-n-slate-9 normal-case font-normal">· {{ positionLabel }}</span>
    </div>
    <div
      class="text-xs text-n-slate-12 prose prose-sm max-w-none [&_p]:my-0"
      v-html="formattedSignature"
    />
    <p class="text-[10px] text-n-slate-9 italic">
      {{ t('CONVERSATION.REPLYBOX.SIGNATURE_PREVIEW.HINT') }}
    </p>
  </div>
</template>
